module.exports = __webpack_public_path__ + "img/card6.2a9b0102.jpg";